/* eslint-disable camelcase */
export interface ICreateProjectDTO {
  name: string;
  description: string;
  start_date?: string;
  end_date?: Date;
  state: string;
  category_id: string;
  enterprise_id: string;
}

export class CreateProjectDTO {
  public name: string;

  public description: string;

  public start_date?: string;

  public end_date?: Date;

  public state: string;

  public category_id: string;

  public enterprise_id: string;

  constructor(data: ICreateProjectDTO) {
    this.name = data.name;
    this.description = data.description;
    this.start_date = data.start_date;
    this.end_date = data.end_date;
    this.state = data.state;
    this.category_id = data.category_id;
    this.enterprise_id = data.enterprise_id;
  }
}
